// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import ClassNames from "classnames"

import Icon from "./icon"
import FreeProductModal from "./modals/free-product"
import TaskModal from "./modals/task"
import type {Dispatch, TaskType} from "../types"

type Props = {
  +t: any,
  +babyToken: string,
  +dispatch: Dispatch,
}

type ModalType = "task" | "free_product"

type State = {
  +isActive: boolean,
  +isModalOpen: boolean,
  +modalType: ?ModalType,
  +taskType: ?TaskType,
}

class ActionDot extends React.Component<Props, State> {
  handleToggleActive: () => void
  handleCloseModal: () => void
  handleAfterOpen: () => void

  // Tasks
  handleAddGeneralTask: () => void
  handleAddMadamTask: () => void
  handleAddClientTask: () => void
  handleAddFreeProduct: () => void

  state = {
    isActive: false,
    isModalOpen: false,
    modalType: null,
    taskType: null,
  }

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.handleToggleActive = this.handleToggleActive.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleAfterOpen = this.handleAfterOpen.bind(this)

    // Tasks
    this.handleAddClientTask = this.handleAddClientTask.bind(this)
    this.handleAddMadamTask = this.handleAddMadamTask.bind(this)
    this.handleAddGeneralTask = this.handleAddGeneralTask.bind(this)
    this.handleAddFreeProduct = this.handleAddFreeProduct.bind(this)
  }

  handleToggleActive() {
    this.setState({isActive: !this.state.isActive})
  }

  handleAfterOpen() {}

  handleCloseModal() {
    this.setState({isModalOpen: false})
  }

  showTaskModal(type: TaskType) {
    this.setState({
      taskType: type,
      modalType: "task",
      isModalOpen: true,
      isActive: false,
    })
  }

  handleAddMadamTask() {
    this.showTaskModal("madam")
  }

  handleAddGeneralTask() {
    this.showTaskModal("general")
  }

  handleAddClientTask() {
    this.showTaskModal("client")
  }

  handleAddFreeProduct() {
    this.setState({
      modalType: "free_product",
      isModalOpen: true,
      isActive: false,
    })
  }

  renderModal() {
    const {isModalOpen, taskType, modalType} = this.state
    if (!isModalOpen) {
      return null
    }
    const {babyToken} = this.props
    switch (modalType) {
      case "task":
        return (
          <TaskModal
            handleCloseModal={this.handleCloseModal}
            handleAfterOpen={this.handleAfterOpen}
            babyToken={babyToken}
            type={taskType}
          />
        )
      case "free_product":
        return (
          <FreeProductModal
            handleCloseModal={this.handleCloseModal}
            handleAfterOpen={this.handleAfterOpen}
            babyToken={babyToken}
          />
        )
    }
    return null
  }

  render() {
    const {isActive} = this.state
    const {t} = this.props
    const classNames = ClassNames("action-dot", {"is-active": isActive})
    return (
      <>
        <div className={classNames}>
          <div className="action-dot-wrapper">
            <div className="action-dot-dot">
              <button
                className="action-dot-button"
                onClick={this.handleToggleActive}
              >
                <Icon name="icon-plus" />
              </button>
              <ul className="action-dot-menu">
                <li className="action-dot-menu-item">
                  <a href="#" onClick={this.handleAddFreeProduct}>
                    {t("actionDot.actions.addFreeProduct")}
                  </a>
                </li>
                <li className="action-dot-menu-item">
                  <a href="#" onClick={this.handleAddMadamTask}>
                    {t("actionDot.actions.addMadamTask")}
                  </a>
                </li>
                <li className="action-dot-menu-item">
                  <a href="#" onClick={this.handleAddClientTask}>
                    {t("actionDot.actions.addClientTask")}
                  </a>
                </li>
                <li className="action-dot-menu-item">
                  <a href="#" onClick={this.handleAddGeneralTask}>
                    {t("actionDot.actions.addGeneralTask")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {this.renderModal()}
      </>
    )
  }
}

export default withTranslation()(connect()(ActionDot))
